import { MusePeer } from '@/services/RoomContextMusePeer'
import { useMemo } from 'react'
import { Video2, VideoSource } from '../../shared/Video2'
import { useUserContext } from '@/UserContext'
import { CameraControlsOverlay } from '../../shared/CameraControlsOverlay'
import ReactionOverlay from '../../shared/ReactionOverlay'
import { UsernameOverlay } from '../../shared/UsernameOverlay'
import { VideoOptionsOverlay } from '../../shared/VideoOptionsOverlay'
import { cn } from '@/utlis/cn'

type SidebarVideoProps = {
    user: MusePeer | 'me'
    videoClassName?: string
}

export function SidebarCamera(props: SidebarVideoProps) {
    const [userState] = useUserContext()
    const vid = useMemo(() => {
        if (props.user === 'me') {
            return new VideoSource(
                'me',
                'camera',
                userState.mediaStreams.video ?? undefined,
                userState.mediaStreams.videoProcessor?.id
            )
        } else {
            return new VideoSource(props.user, 'camera', props.user.remoteVideo ?? undefined)
        }
    }, [props.user, userState.mediaStreams.video, userState.mediaStreams.videoProcessor?.id])

    const userId = props.user === 'me' ? userState.userUrn : props.user.userUrn

    return (
        <div className="relative group w-full">
            <CameraControlsOverlay peer={props.user} sidebar />
            <ReactionOverlay userUrn={userId} />
            <UsernameOverlay size="small" peer={props.user} />
            <VideoOptionsOverlay peer={props.user} kind="camera" hidePin size="small" />
            <Video2
                key={vid.id}
                videoSource={vid}
                ignoreAspectRatio
                className={cn('w-full aspect-16/9 object-cover rounded-t-[16px]', props.videoClassName)}
            />
        </div>
    )
}
